export type TGiftCardsActiveCard = {
  nominal: number;
  cardNumber: string;
  cardId?: string;
  expireDate: string;
  status: 'active' | 'notActive' | 'blocked';
  availAmnt: number;
  product: {
    _id: string;
    name: {
      [key: string]: string;
    };
    imageUrl: string;
  };
  giftMessage?: {
    message: string;
    recipientName: string;
    senderName: string;
  };
};
export type TGiftCardsArchiveCard = {
  nominal: number;
  cardId?: string;
  cardNumber: string;
  expireDate: string;
  status: 'active' | 'notActive' | 'blocked';
  availAmnt: number;
  product: {
    _id: string;
    name: {
      [key: string]: string;
    };
    imageUrl: string;
  };
  giftMessage?: {
    message: string;
    recipientName: string;
    senderName: string;
  };
};

export type TGiftCardsData = {
  active: TGiftCardsActiveCard[];
  archive: TGiftCardsArchiveCard[];
};

export async function getGiftCardsData(token?: string): Promise<TGiftCardsData> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/clients/gift-cards`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const jsonData: TGiftCardsData = await res.json();
  return jsonData;
}

export type TCardOperationItem = {
  operationType: 'activation' | 'sale' | 'return' | 'refund';
  cardNumber: string;
  operationDetail: {
    operationId: string;
    operationCode: string;
    operationDateTime: string;
    register: string;
    smena: string;
    check: string;
    checkAmnt: number;
    checkDiscount: number;
    value: number;
    checkDetail?: {
      brandId: string;
      value: number;
      brand?: {
        _id: string;
        name: {
          [key: string]: string;
        };
        deptIds: string[];
        image: string;
      } | null;
    }[];
  };
  card: {
    _id: string;
    nominal: number;
    cardNumber: string;
    product: {
      name: {
        [key: string]: string;
      };
      imageUrl: string;
    };
  };
};

export type TCardOperationDateItem = {
  date: string;
  operations: TCardOperationItem[];
};

export async function getCardOperationsList(
  startDate: string,
  endDate?: string,
  token?: string,
): Promise<TCardOperationDateItem[]> {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/clients/gift-cards/operations?startDate=${startDate}${
      endDate ? `&endDate=${endDate}` : ''
    }`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const jsonData: TCardOperationDateItem[] = await res.json();
  return jsonData;
}

export async function getLastCardOperationsList(token?: string): Promise<TCardOperationDateItem[]> {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/clients/gift-cards/lastOperations`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const jsonData: TCardOperationDateItem[] = await res.json();
  return jsonData;
}

export async function getCurrentCardOperationsList(
  cardNumber: string,
  startDate: string,
  endDate?: string,
  token?: string,
): Promise<TCardOperationDateItem[]> {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/api/v1/clients/gift-cards/${cardNumber}/operations?startDate=${startDate}${
      endDate ? `&endDate=${endDate}` : ''
    }`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const jsonData: TCardOperationDateItem[] = await res.json();
  return jsonData;
}
